import React from 'react';
import { trackEvent } from '../utils/analytics';

// ⚠️ AÇÃO NECESSÁRIA: Substituir o número abaixo pelo número real da Gruty no WhatsApp Business.
// Formato: https://wa.me/<DDI><DDD><NUMERO>?text=...
const WHATSAPP_URL =
  'https://wa.me/12894072563?text=Ol%C3%A1%2C+vim+pelo+site+da+Gruty';

export function WhatsAppButton() {
  const handleClick = () => {
    trackEvent('whatsapp_click', { location: 'floating_button' });
  };

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#25D366] hover:bg-[#1ebe57] transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-[#25D366]/40"
    >
      {/* WhatsApp SVG icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-8 h-8"
        fill="white"
        aria-hidden="true"
      >
        <path d="M16.003 3C9.374 3 4 8.373 4 15.003c0 2.118.554 4.18 1.607 5.997L4 29l8.225-1.576A12.007 12.007 0 0 0 16.003 28C22.63 28 28 22.628 28 15.003 28 8.373 22.63 3 16.003 3zm0 21.9c-1.87 0-3.7-.506-5.302-1.464l-.38-.226-3.94.754.789-3.836-.248-.394A9.883 9.883 0 0 1 6.1 15c0-5.465 4.44-9.9 9.904-9.9 5.462 0 9.9 4.435 9.9 9.9 0 5.468-4.438 9.9-9.9 9.9zm5.44-7.408c-.299-.149-1.768-.873-2.042-.97-.274-.1-.474-.15-.674.15-.2.298-.773.97-.948 1.17-.174.199-.348.224-.647.075-.298-.15-1.258-.463-2.396-1.478-.885-.79-1.482-1.765-1.656-2.063-.173-.299-.018-.46.13-.608.133-.133.298-.348.448-.522.15-.175.2-.3.3-.499.1-.199.05-.374-.025-.523-.074-.15-.673-1.619-.922-2.218-.243-.582-.49-.503-.673-.513l-.573-.01a1.098 1.098 0 0 0-.797.374c-.274.298-1.047 1.022-1.047 2.493 0 1.47 1.072 2.892 1.22 3.09.15.199 2.108 3.217 5.108 4.512.714.308 1.271.492 1.705.63.716.228 1.368.196 1.883.119.574-.085 1.768-.723 2.018-1.42.249-.698.249-1.297.174-1.42-.075-.124-.274-.2-.573-.35z" />
      </svg>
    </a>
  );
}
